import { Control } from '@yleisradio/areena-types';
import { Controls } from 'components/Controls';
import React from 'react';
import styles from './HighlightControls.module.scss';

type Props = {
  controls: Control[];
  trackLinkClick: (() => void) | undefined;
  trackPlayClick: (() => void) | undefined;
};

export const HighlightControls: React.FunctionComponent<Props> = ({
  controls,
  trackLinkClick,
  trackPlayClick,
}) => {
  return (
    <>
      <div className={styles.mobile}>
        <Controls
          controls={controls}
          as="button"
          direction="horizontal"
          size="xs"
          trackLinkClick={trackLinkClick}
          trackPlayClick={trackPlayClick}
        />
      </div>
      <div className={styles.desktop}>
        <Controls
          controls={controls}
          as="button"
          direction="horizontal"
          size="sm"
          trackLinkClick={trackLinkClick}
          trackPlayClick={trackPlayClick}
        />
      </div>
    </>
  );
};
